import { Mark, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwContentLink: {
      setNWContentLink: () => ReturnType;
    };
  }
}

export const NWContentLinkAdapter = Mark.create({
  name: "nw-content-link",

  keepOnSplit: true,
  inclusive: true,
  exitable: true,
  spanning: true,

  addAttributes() {
    return {
      to: {
        default: null,
        parseHTML: element => element.getAttribute("to"),
        renderHTML: attributes => ({
          to: attributes.to,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-content-link[to]",
        getAttrs: element => {
          if (!(element instanceof HTMLElement)) {
            return false;
          }
          return {
            to: element.getAttribute("to"),
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-content-link", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  addCommands() {
    return {
      setNWContentLink:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          });
        },
    };
  },
});
